import React from 'react';
import { useSitePageLinkEnhancements } from './SitePageLinkEnhancements';

type SupportedElement = keyof JSX.IntrinsicElements;

interface SitePageHtmlContentProps {
    html: string;
    as?: SupportedElement;
    className?: string;
}

export const SitePageHtmlContent: React.FC<SitePageHtmlContentProps> = ({
    html,
    as = 'div',
    className,
}) => {
    const elementRef = React.useRef<HTMLElement | null>(null);
    useSitePageLinkEnhancements(elementRef, html);

    const Component = as as unknown as keyof JSX.IntrinsicElements;
    const ComponentTag = Component as unknown as React.ElementType;

    return (
        <ComponentTag
            ref={elementRef as unknown as React.Ref<HTMLElement>}
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};
